export const MEMBERSHIP_ACTION_CONFIRM = {
  nonMember: {
    title: "Make Non Member",
    description: "Are you sure you want to make this user a non-member?",
    confirmText: "Confirm",
  },
  lifetime: {
    title: "Make Lifetime Member",
    description: "Are you sure you want to make this user a lifetime member?",
    confirmText: "Confirm",
  },
  removeVip: {
    title: "Remove VIP",
    description: "Are you sure you want to remove VIP from this user?",
    confirmText: "Remove",
  },
  vipAccess: {
    title: "VIP Access",
    description: "Are you sure you want to give this user VIP access?",
    confirmText: "Confirm",
  },
  removeVipAccess: {
    title: "Remove VIP Access",
    description: "Are you sure you want to remove VIP access from this user?",
    confirmText: "Remove",
  },
};
